var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('read', 'deposit-gateway'))?_c('main-content',[(this.$route.params.gateway_source === 'pf')?_c('manage-deposit-pf'):_vm._e(),(this.$route.params.gateway_source === 'starshop')?_c('manage-deposit-starshop'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }